import React from 'react';
import t from 'react-translate';
import { useSelector } from 'react-redux';
import NvIcon from 'shared/components/nv-icon';
import { getCourseAliases } from 'redux/selectors/course';
import { TeachingTeamAliases } from 'redux/schemas/models/course';
import { helpResourcesTemplateStyles } from './styles';

// This component isn't rendered directly, but contains the HTML template
// that will be copied into the NvFroala editor
const HelpResourcesTemplate = () => {
  const aliases = useSelector(getCourseAliases);
  return (
    <div css={helpResourcesTemplateStyles}>
      <div className='section-items'>
        <NvIcon size='smallest' icon='admin-dashboard' />
        <NvIcon size='smallest' icon='gallery' />
        <NvIcon size='smallest' icon='conversations' />
        <NvIcon size='smallest' icon='help' />
      </div>
      <div className='help-container'>
        <span className='need-help'>{t.INSTITUTIONS.ADVANCED_SETTINGS.HELP_OPTIONS.HELP_RESOURCES.TEMPLATE_TITLE()}</span>
        <p>{t.INSTITUTIONS.ADVANCED_SETTINGS.HELP_OPTIONS.HELP_RESOURCES.TEMPLATE_CONTACT_TEXT(aliases?.teachingTeamAliases)}</p>
        <p><a href='mailto:replace_email@domain.com'>replace_email@domain.com</a></p>
        <p className='platform'>{t.INSTITUTIONS.ADVANCED_SETTINGS.HELP_OPTIONS.HELP_RESOURCES.TEMPLATE_PLATFORM_TEXT()}</p>
        <p><a href='#' target='_blank'>{t.INSTITUTIONS.ADVANCED_SETTINGS.HELP_OPTIONS.HELP_RESOURCES.TEMPLATE_HELP_ARTICLES()}</a></p>
      </div>
    </div>
  );
};

// Export the template as HTML string to be inserted into the editor
export const getHelpResourcesTemplateHtml = (teachingTeamAliases: TeachingTeamAliases): string => `<div style="color: black; text-align: left;">
  <p style="margin-bottom: 0px;">${t.INSTITUTIONS.ADVANCED_SETTINGS.HELP_OPTIONS.HELP_RESOURCES.TEMPLATE_CONTACT_TEXT(teachingTeamAliases)}</p>
  <p style="margin-bottom: 0px;"><a href="mailto:replace_email@domain.com">replace_email@domain.com</a></p>
  <p style="margin-top: 10px; margin-bottom: 0px;">${t.INSTITUTIONS.ADVANCED_SETTINGS.HELP_OPTIONS.HELP_RESOURCES.TEMPLATE_PLATFORM_TEXT()}</p>
  <p><a href="#" target="_blank">${t.INSTITUTIONS.ADVANCED_SETTINGS.HELP_OPTIONS.HELP_RESOURCES.TEMPLATE_HELP_ARTICLES()}</a></p>
</div>`;

export default HelpResourcesTemplate;
